"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _uiTheme = require("@kyruus/ui-theme");
const MenuComponent = (0, _uiTheme.withMuiThemeAdapter)(_Menu.default);
// This is silly, but it optimizes for developers.
// react-docgen can't find the propTypes unless it
// sees a component defininition.
const Menu = props => /*#__PURE__*/_react.default.createElement(MenuComponent, props);
Menu.displayName = 'Menu';

// PropTypes taken from material-ui.
Menu.propTypes = {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes.default.object,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,
  /**
   * Properties applied to the `MenuList` element.
   */
  MenuListProps: _propTypes.default.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,
  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes.default.func,
  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes.default.func,
  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes.default.func,
  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes.default.func,
  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes.default.func,
  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes.default.func,
  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes.default.bool.isRequired,
  /**
   * `classes` property applied to the `Popover` element.
   */
  PopoverClasses: _propTypes.default.object,
  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
};
Menu.defaultProps = {
  transitionDuration: 'auto'
};
var _default = exports.default = Menu;
Menu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Menu",
  "props": {
    "transitionDuration": {
      "defaultValue": {
        "value": "'auto'",
        "computed": false
      },
      "description": "The length of the transition in `ms`, or 'auto'",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "shape",
          "value": {
            "enter": {
              "name": "number",
              "required": false
            },
            "exit": {
              "name": "number",
              "required": false
            }
          }
        }, {
          "name": "enum",
          "value": [{
            "value": "'auto'",
            "computed": false
          }]
        }]
      },
      "required": false
    },
    "anchorEl": {
      "description": "The DOM element used to set the position of the menu.",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "children": {
      "description": "Menu contents, normally `MenuItem`s.",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "MenuListProps": {
      "description": "Properties applied to the `MenuList` element.",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "onClose": {
      "description": "Callback fired when the component requests to be closed.\n\n@param {object} event The event source of the callback",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onEnter": {
      "description": "Callback fired before the Menu enters.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onEntered": {
      "description": "Callback fired when the Menu has entered.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onEntering": {
      "description": "Callback fired when the Menu is entering.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onExit": {
      "description": "Callback fired before the Menu exits.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onExited": {
      "description": "Callback fired when the Menu has exited.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onExiting": {
      "description": "Callback fired when the Menu is exiting.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "open": {
      "description": "If `true`, the menu is visible.",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "PopoverClasses": {
      "description": "`classes` property applied to the `Popover` element.",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};